import React from 'react';
import PdfFileIcon from '@grnhse/seedling/lib/birch/icons/pdf_file';
import RtfFileIcon from '@grnhse/seedling/lib/birch/icons/rtf_file';
import DocFileIcon from '@grnhse/seedling/lib/birch/icons/doc_file';
import DocxFileIcon from '@grnhse/seedling/lib/birch/icons/docx_file';
import TxtFileIcon from '@grnhse/seedling/lib/birch/icons/txt_file';
import FormsIcon from '@grnhse/seedling/lib/birch/icons/forms';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';

const DocumentIcon = ({
  extension,
  size,
}: {
  extension: string | 'pdf' | 'rtf' | 'doc' | 'docx' | 'txt';
  size?: 'sm' | 'md' | 'lg';
}) => {
  switch (extension) {
    case 'pdf':
      return (
        <PdfFileIcon
          size={size}
          color={FullPalette.POPPY_700}
          data-provides="pdf-icon"
        />
      );
    case 'rtf':
      return (
        <RtfFileIcon
          size={size}
          color={FullPalette.EVERGREEN_700}
          data-provides="rtf-icon"
        />
      );
    case 'doc':
      return (
        <DocFileIcon
          size={size}
          color={FullPalette.IRIS_700}
          data-provides="doc-icon"
        />
      );
    case 'docx':
      return (
        <DocxFileIcon
          size={size}
          color={FullPalette.IRIS_700}
          data-provides="docx-icon"
        />
      );
    case 'txt':
      return (
        <TxtFileIcon
          size={size}
          color={FullPalette.EVERGREEN_700}
          data-provides="txt-icon"
        />
      );
    default:
      return <FormsIcon size={size} data-provides="other-document-icon" />;
  }
};

export default DocumentIcon;
